var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "viq-board-report" },
    [
      _c(
        "div",
        { staticClass: "viq-board-report__steps" },
        _vm._l(_vm.steps, function (step, i) {
          return _c(
            "div",
            {
              key: i,
              staticClass: "viq-board-report__step",
              class: {
                "viq-board-report__step--active": _vm.reportStep === i + 1,
                "viq-board-report__step--done": _vm.reportStep > i + 1,
              },
            },
            [
              _c("span", { staticClass: "viq-board-report__step-num" }, [
                _vm._v(_vm._s(i + 1)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "viq-board-report__step-label" }, [
                _vm._v(_vm._s(step)),
              ]),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.reportStep === 1
        ? _c("ViqReportBriefing", { on: { submit: _vm.handleBriefing } })
        : _vm.reportStep === 2
        ? _c("ViqReportOutlineEditor", {
            attrs: { outline: _vm.reportOutline },
            on: {
              confirm: _vm.handleOutlineConfirm,
              refine: _vm.handleOutlineRefine,
            },
          })
        : _vm.reportStep === 3
        ? _c("ViqReportSectionStream", {
            attrs: { sections: _vm.reportSections },
          })
        : _vm.reportStep === 4
        ? _c("ViqReportExecSummary", {
            attrs: {
              summary: _vm.reportExecSummary,
              sections: _vm.reportSections,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }